<mat-card-title mat-dialog-title class="d-flex align-items-center mb-0"
  ><mat-icon>filter_alt</mat-icon>
  {{
    'configurable-fields.formula-builder.define-reference-filters.title'
      | translate
  }}
</mat-card-title>
<mat-card-subtitle>{{
  'configurable-fields.formula-builder.define-reference-filters.sub-title'
    | translate
}}</mat-card-subtitle>
<mat-divider></mat-divider>
<mat-dialog-content class="main-container">
  <div class="row header-row">
    <h6>
      {{
        'configurable-fields.formula-builder.define-reference-filters.filter'
          | translate
      }}
    </h6>

    <button
      (click)="addForm()"
      mat-stroked-button
      style="font-size: small"
      [matTooltip]="
        'configurable-fields.formula-builder.define-reference-filters.new-filter-button'
          | translate
      "
    >
      {{
        'configurable-fields.formula-builder.define-reference-filters.new-filter-button'
          | translate
      }}
    </button>
  </div>
  <form class="container">
    @for (field of fields; track field; let i = $index) {
    <div class="row filter-row">
      <mat-form-field appearance="fill" class="filter-element">
        <mat-label>
          {{
            'configurable-fields.formula-builder.define-reference-filters.field-name'
              | translate
          }}
        </mat-label>
        <mat-select
          placeholder="Field Name"
          required
          [formControl]="field.foreignField"
          hideSingleSelectionIndicator="true"
        >
          @for (field of foreignReferenceFields; track field) {
          <mat-option [value]="field._id">
            {{ field.name }}
          </mat-option>
          }
        </mat-select>
        <mat-error>{{
          'configurable-fields.formula-builder.define-reference-filters.name-required'
            | translate
        }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="filter-element">
        <mat-label>
          {{
            'configurable-fields.formula-builder.define-reference-filters.comparison-type'
              | translate
          }}</mat-label
        >
        <mat-select
          placeholder="Comparison Type"
          required
          [formControl]="field.comparisonType"
          [disabled]="!field.foreignField.value"
          hideSingleSelectionIndicator="true"
        >
          @for (type of COMPARISON_TYPES; track type) {
          <mat-option [value]="type">
            {{ type }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="filter-element">
        <mat-label>
          {{
            'configurable-fields.formula-builder.define-reference-filters.compare-with'
              | translate
          }}</mat-label
        >
        <mat-select
          placeholder="Compare With"
          required
          [formControl]="field.compareWith"
          [disabled]="!field.foreignField.value"
          (valueChange)="setFieldItem(i, $event)"
          hideSingleSelectionIndicator="true"
        >
          <mat-option value="local">
            {{
              'configurable-fields.formula-builder.define-reference-filters.local-field'
                | translate
            }}
          </mat-option>
          <mat-option value="direct">
            {{
              'configurable-fields.formula-builder.define-reference-filters.direct'
                | translate
            }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      @if (field.compareWith.value === 'local') {
      <mat-form-field appearance="fill" class="filter-element">
        <mat-label>
          {{
            'configurable-fields.formula-builder.define-reference-filters.compare-value'
              | translate
          }}</mat-label
        >
        <mat-select
          placeholder="Field Name"
          required
          [formControl]="field.compareValue"
          [disabled]="!field.foreignField.value"
          hideSingleSelectionIndicator="true"
        >
          @for (field of localReference?.fields || []; track field) {
          <mat-option [value]="field._id">
            {{ field.name }}
          </mat-option>
          }
        </mat-select>
        <mat-error>{{
          'configurable-fields.formula-builder.define-reference-filters.value-required'
            | translate
        }}</mat-error>
      </mat-form-field>
      } @if (field.compareWith.value === 'direct' && field.fieldItem) {
      <div class="filter-element">
        <app-display-single-configurable-field
          [fieldItem]="field.fieldItem"
          [disabled]="!field.foreignField.value"
        ></app-display-single-configurable-field>
      </div>
      }
      <button
        mat-icon-button
        (click)="removeForm(i)"
        type="button"
        matTooltip="Delete"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    [mat-dialog-close]="false"
    [matTooltip]="
      'configurable-fields.formula-builder.define-reference-filters.close'
        | translate
    "
  >
    {{
      'configurable-fields.formula-builder.define-reference-filters.close'
        | translate
    }}
  </button>
  <button
    mat-raised-button
    cdkFocusInitial
    color="primary"
    [matTooltip]="
      'configurable-fields.formula-builder.define-reference-filters.save'
        | translate
    "
    [disabled]="isAllValid()"
    (click)="save()"
  >
    {{
      'configurable-fields.formula-builder.define-reference-filters.save'
        | translate
    }}
  </button>
</mat-dialog-actions>
